import React, { useEffect, useRef } from "react";
import "./KitchenDetails.css";
import config from "../../config";

// New: Custom hook to load the Google Maps script
const useLoadGoogleMapsScript = (callback) => {
  useEffect(() => {
    if (!document.querySelector(`[src*="maps.googleapis.com"]`)) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${config.mapApiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => callback();
      document.head.appendChild(script);
    } else {
      callback();
    }
  }, [callback]);
};

const KitchenDetails = ({
  editMode,
  kitchenData,
  updateKitchenData,
  openTermsModal,
}) => {
  const cityInputRef = useRef(null);

  // Update centralized state directly on input changes.
  const handleChange = (field, value) => {
    updateKitchenData({ [field]: value });
  };

  // Use the custom hook to load Google Maps script and initialize autocomplete
  useLoadGoogleMapsScript(() => {
    if (window.google && window.google.maps && cityInputRef.current) {
      const autocomplete = new window.google.maps.places.Autocomplete(
        cityInputRef.current,
        { types: ["(cities)"], componentRestrictions: { country: "us" } }
      );
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place && place.formatted_address) {
          handleChange("city", place.formatted_address);
        }
      });
    }
  });

  return (
    <div className="kitchen-details">
      <div className="form-row">
        <div className="form-group">
          <label>Title</label>
          <input
            type="text"
            placeholder="Enter your kitchen title"
            value={kitchenData.title || ""}
            onChange={(e) => handleChange("title", e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Kitchen Type</label>
          <select
            value={kitchenData.category || ""}
            onChange={(e) => handleChange("category", e.target.value)}
          >
            <option value="">Select Category</option>
            <option value="commercial">Commercial Kitchen</option>
            <option value="restaurant">Restaurant Kitchen</option>
            <option value="ghost">Ghost Kitchen</option>
            <option value="bakery">Bakery Kitchen</option>
            <option value="private">Private Kitchen</option>
            <option value="all">All Purpose Kitchen</option>
          </select>
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>Enter your city</label>
          <input
            type="text"
            id="city"
            ref={cityInputRef}
            placeholder="Type the city name"
            value={kitchenData.city || ""}
            onChange={(e) => handleChange("city", e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Kitchen Size</label>
          <select
            value={kitchenData.size || ""}
            onChange={(e) => handleChange("size", e.target.value)}
          >
            <option value="">Select Size</option>
            <option value="small">Small</option>
            <option value="medium">Medium</option>
            <option value="large">Large</option>
          </select>
        </div>
      </div>
      <div className="form-group">
        <label>Kitchen Description</label>
        <textarea
          rows="4"
          placeholder="Describe your Kitchen"
          maxLength="500"
          value={kitchenData.description || ""}
          onChange={(e) => handleChange("description", e.target.value)}
        />
        <small className="char-limit">
          Note: This message will appear below your kitchen listing.
        </small>
      </div>
      <div className="form-group">
        <label>Check-in Message</label>
        <textarea
          rows="6"
          placeholder="Check-In Message for the Renter"
          maxLength="500"
          value={kitchenData.checkinmessage || ""}
          onChange={(e) => handleChange("checkinmessage", e.target.value)}
        />
        <small className="char-limit">
          Note: Please do not share personal information as per company policy.
          All communication will be handled through AirKitchenz. This message
          will be shown only after booking confirmation. Kindly include key/code
          info.
        </small>
      </div>
      <div className="terms-container">
        <input
          type="checkbox"
          id="terms"
          checked={kitchenData.agreed || false}
          onChange={(e) => handleChange("agreed", e.target.checked)}
        />
        <label
          htmlFor="terms"
          onClick={(e) => {
            e.preventDefault();
            openTermsModal();
          }}
        >
          I agree to the{" "}
          <span className="kitchen-terms-link">Terms and Condition</span>
        </label>
      </div>
    </div>
  );
};

export default KitchenDetails;
